import Meta from '@/components/common/Meta'

import CollegeBoxesStoragePage from '@/v2/components/pages/landing-pages/college-boxes-storage-page'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/college-boxes-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'

interface CollegeBoxesStoragePageProps {}

const Page: React.FC<CollegeBoxesStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.college_boxes_storage.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.college_boxes_storage?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.college_boxes_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <CollegeBoxesStoragePage />
    </>
  )
}

export default Page
